import { render } from "./BaseBtnNew.vue?vue&type=template&id=00cff9de&scoped=true"
import script from "./BaseBtnNew.vue?vue&type=script&lang=js"
export * from "./BaseBtnNew.vue?vue&type=script&lang=js"

import "./BaseBtnNew.vue?vue&type=style&index=0&id=00cff9de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cff9de"]])

export default __exports__